// Mobile sticky add-to-cart bar.
// The bar lives inside the native {% form 'product' %} and the 'product-form' partial,
// so its submit button posts the same hidden variant id and quantity input as the main
// Add to cart button, and it is re-rendered with the selected variant on every size change.
// This script only shows the bar once the main button has scrolled out of view.
class SStickyAtc extends HTMLElement {
  #observer;
  #errorObserver;

  connectedCallback() {
    const productForm = this.closest('[data-product-form]');
    const target = productForm?.querySelector('[data-main-atc]');
    if (!target || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      this.#toggle(scrolledPast);
    });
    this.#observer.observe(target);

    // Errors render beside the main button; bring them into view when the bar was used.
    const error = productForm.querySelector('[data-add-to-cart-error]');
    if (error) {
      this.#errorObserver = new MutationObserver(() => {
        if (!error.hidden && !this.hidden) error.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
      this.#errorObserver.observe(error, { attributes: true, attributeFilter: ['hidden'] });
    }
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#errorObserver?.disconnect();
    document.body.style.removeProperty('padding-bottom');
  }

  #toggle(show) {
    const mobile = window.matchMedia('(max-width: 767px)').matches;
    this.hidden = !(show && mobile);
    if (this.hidden) {
      document.body.style.removeProperty('padding-bottom');
    } else {
      document.body.style.paddingBottom = `${this.offsetHeight}px`;
    }
  }
}

if (!customElements.get('s-sticky-atc')) customElements.define('s-sticky-atc', SStickyAtc);
